module.exports = __webpack_public_path__ + "static/media/logout.c0abc753.svg";